export default {
  name: "Company",
  path: "/company",
  component: () => import("@/views/member/company"),
  meta: {
    layout: "default",
    isActive: false,
    text: "회사 관리",
    icon: "company.svg"
  },
  redirect: {
    name: "StatisticsList"
  },
  children: [
    {
      name: "StatisticsList",
      path: "/company/statistics",
      component: () => import("@/views/member/company/pages/statistics"),
      meta: {
        menuMember: true,
        text: "업체목록"
      }
    },
    {
      name: "CompanyCreate",
      path: "/company/Create",
      component: () => import("@/views/member/company/pages/create"),
      meta: {
        menuMember: true,
        text: "회사생성"
      }
    },
    {
      name: "CompanyUsers",
      path: "/company/userList",
      component: () => import("@/views/member/user/pages/userList"),
      meta: {
        menuMember: true,
        text: "회사별 회원 현황"
      }
    },
    {
      name: "CompanyRetails",
      path: "/company/retailList",
      component: () => import("@/views/member/company/pages/retailList"),
      meta: {
        menuMember: true,
        text: "회사별 파트너 현황"
      }
    },
//    {
//      name: "CompanyDetail",
//      path: "/company/detail",
//      component: () => import("@/views/member/company/pages/detail"),
//      meta: {
//        menuMember: true,
//        text: "상세보기"
//      }
//    },
    {
      name: "companyDetail",
      path: "/company/detail",
      component: () => import("@/views/member/company/pages/detail"),
      meta: {
        menuMember: true,
        isActive: true
      },
      children: [
        {
          name: "companyDetails",
          path: "/company/detail/company",
          component: () => import("@/views/member/company/pages/detail"),
          meta: {
            menuMember: false,
            isActive: false
          }
        },
        {
          name: "userDetail",
          path: "/company/detail/user",
          component: () => import("@/views/member/user/pages/detail"),
          meta: {
            menuMember: false,
            isActive: false
          }
        }
      ]
    },
    {
      name: "gameBet",
      path: "/company/game/bet",
      component: () => import("@/views/member/company/pages/game/gameBet"),
      meta: {
        menuMember: false,
        isActive: false
      }
    },
    {
      name: "gameRate",
      path: "/company/game/rate",
      component: () => import("@/views/member/company/pages/game/gameRate"),
      meta: {
        menuMember: false,
        isActive: false
      }
    },
    {
      name: "gameList",
      path: "/company/game/list",
      component: () => import("@/views/member/company/pages/game/gameList"),
      meta: {
        menuMember: false,
        isActive: false
      }
    },
    {
      name: "gameUi",
      path: "/company/game/ui",
      component: () => import("@/views/member/company/pages/game/gameUi"),
      meta: {
        menuMember: false,
        isActive: false
      }
    }
    ,
    {
      name: "skin",
      path: "/company/game/skin",
      component: () => import("@/views/member/company/pages/game/skin"),
      meta: {
        menuMember: false,
        isActive: false
      }
    }
  ]
};
